export default "__VITE_ASSET__Dbqct1Am__"